const itemWidths = {
    DESC: '58%',
    PRICE: '16%',
    QTY: '6%',
    AMOUNT: '20%'
};

export { itemWidths };
